// Generated by ReScript, PLEASE EDIT WITH CARE


function getEmailAndPhoneByAuctionLocation(auctionLocation) {
  switch (auctionLocation) {
    case /* NewYorkAuction */0 :
        return [
                "bids.newyork@sothebys.com",
                "+1 212 606 7414"
              ];
    case /* LondonAuction */1 :
        return [
                "bids.london@sothebys.com",
                "+44 20 7293 5283"
              ];
    case /* GenevaAuction */2 :
        return [
                "bids.geneva@sothebys.com",
                "+41 22 908 4888"
              ];
    case /* ParisAuction */4 :
        return [
                "bids.paris@sothebys.com",
                "+33 1 5305 5348"
              ];
    case /* MilanAuction */5 :
        return [
                "bids.milan@sothebys.com",
                "+39 02 295 00239"
              ];
    case /* ZurichAuction */6 :
        return [
                "bids.zurich@sothebys.com",
                "+41 44 226 22 00"
              ];
    case /* MumbaiAuction */7 :
        return [
                "bids.mumbai@sothebys.com",
                "+44 20 7293 5283"
              ];
    case /* DubaiAuction */8 :
        return [
                "bids.dubai@sothebys.com",
                "+44 20 7293 5283"
              ];
    case /* DohaAuction */9 :
        return [
                "bids.doha@sothebys.com",
                "+44 20 7293 5283"
              ];
    case /* SingaporeAuction */10 :
        return [
                "bids.singapore@sothebys.com",
                "+65 6732 8239"
              ];
    case /* CologneAuction */11 :
        return [
                "bids.germany@sothebys.com",
                "+49 221 20 71 70"
              ];
    case /* HongKongAuction */3 :
    case /* BeijingAuction */12 :
        return [
                "bids.hongkong@sothebys.com",
                "+852 2822 8142"
              ];
    case /* RiyadhAuction */13 :
        return [
                "bids.riyadh@sothebys.com",
                "+44 20 7293 5283"
              ];
    
  }
}

function getBidDepartmentContactForAuctionLocation(auctionLocation) {
  var tmp;
  switch (auctionLocation) {
    case /* NewYorkAuction */0 :
        tmp = /* NewYorkAuction */0;
        break;
    case /* GenevaAuction */2 :
        tmp = /* GenevaAuction */2;
        break;
    case /* HongKongAuction */3 :
        tmp = /* HongKongAuction */3;
        break;
    case /* ParisAuction */4 :
        tmp = /* ParisAuction */4;
        break;
    case /* MilanAuction */5 :
        tmp = /* MilanAuction */5;
        break;
    case /* ZurichAuction */6 :
        tmp = /* ZurichAuction */6;
        break;
    case /* LondonAuction */1 :
    case /* MumbaiAuction */7 :
    case /* DubaiAuction */8 :
        tmp = /* LondonAuction */1;
        break;
    case /* DohaAuction */9 :
        tmp = /* DohaAuction */9;
        break;
    case /* SingaporeAuction */10 :
        tmp = /* SingaporeAuction */10;
        break;
    case /* CologneAuction */11 :
        tmp = /* CologneAuction */11;
        break;
    case /* BeijingAuction */12 :
        tmp = /* BeijingAuction */12;
        break;
    case /* RiyadhAuction */13 :
        tmp = /* RiyadhAuction */13;
        break;
    
  }
  return getEmailAndPhoneByAuctionLocation(tmp);
}

function getAuctionLocationType(auctionLocation) {
  var match = auctionLocation.toLowerCase();
  switch (match) {
    case "beijing" :
        return /* BeijingAuction */12;
    case "cologne" :
        return /* CologneAuction */11;
    case "doha" :
        return /* DohaAuction */9;
    case "dubai" :
        return /* DubaiAuction */8;
    case "geneva" :
        return /* GenevaAuction */2;
    case "hong kong" :
        return /* HongKongAuction */3;
    case "london" :
        return /* LondonAuction */1;
    case "milan" :
        return /* MilanAuction */5;
    case "mumbai" :
        return /* MumbaiAuction */7;
    case "new york" :
        return /* NewYorkAuction */0;
    case "paris" :
        return /* ParisAuction */4;
    case "riyadh" :
        return /* RiyadhAuction */13;
    case "singapore" :
        return /* SingaporeAuction */10;
    case "zurich" :
        return /* ZurichAuction */6;
    default:
      return /* NewYorkAuction */0;
  }
}

function auctionLocationToSaleLocation($$location) {
  switch ($$location) {
    case /* NewYorkAuction */0 :
        return "NEW_YORK";
    case /* LondonAuction */1 :
        return "LONDON";
    case /* GenevaAuction */2 :
        return "GENEVA";
    case /* HongKongAuction */3 :
        return "HONG_KONG";
    case /* ParisAuction */4 :
        return "PARIS";
    case /* ZurichAuction */6 :
        return "ZURICH";
    case /* SingaporeAuction */10 :
        return "SINGAPORE";
    case /* CologneAuction */11 :
        return "COLOGNE";
    case /* MilanAuction */5 :
    case /* MumbaiAuction */7 :
    case /* DubaiAuction */8 :
    case /* DohaAuction */9 :
    case /* BeijingAuction */12 :
    case /* RiyadhAuction */13 :
        return ;
    
  }
}

function saleLocationToJs($$location) {
  if ($$location === "NEW_YORK") {
    return "NEW_YORK";
  } else if ($$location === "SINGAPORE") {
    return "SINGAPORE";
  } else if ($$location === "HONG_KONG") {
    return "HONG_KONG";
  } else if ($$location === "COLOGNE") {
    return "COLOGNE";
  } else if ($$location === "LONDON") {
    return "LONDON";
  } else if ($$location === "ZURICH") {
    return "ZURICH";
  } else if ($$location === "PARIS") {
    return "PARIS";
  } else {
    return "GENEVA";
  }
}

var usNumber = "+1 212 606 7000";

var ukNumber = "+44 (0) 20 7293 5000";

var hongKongNumber = "+852 2822 5533";

var singaporeNumber = "+65 6732 8239";

var frNumber = "+33 1 53 05 53 05";

var enquiriesEmail = "enquiries@sothebys.com";

export {
  getEmailAndPhoneByAuctionLocation ,
  getBidDepartmentContactForAuctionLocation ,
  getAuctionLocationType ,
  auctionLocationToSaleLocation ,
  saleLocationToJs ,
  usNumber ,
  ukNumber ,
  hongKongNumber ,
  singaporeNumber ,
  frNumber ,
  enquiriesEmail ,
}
/* No side effect */
